/**
 * Frontend types for products and featured products.
 * Product / PurchaseOption mirror the backend listing Product schema
 * (details + purchase_options) returned by /api/products/*.
 */

export type FeaturedContext =
  | "homepage"
  | "sidebar"
  | "hero"
  | "footer"
  | "collection";

export const FEATURED_CONTEXTS: FeaturedContext[] = [
  "homepage",
  "sidebar",
  "hero",
  "footer",
  "collection",
];

export interface ProductDetails {
  id: number | null;
  external_id: string;
  name: string;
  url: string;
  source: string | null;
  source_name?: string | null;
  image_url: string | null;
  housing: string | null;
  housing_count?: number | null;
  manufacturer: string | null;
  category: string | null;
  gain_control: string | null;
  restricted_to: string[] | null;
  lead_time: number | null;
  housing_price?: string | null;
  housing_regular_price?: string | null;
  description?: string | null;
  review_status?: string | null;
}

export interface PurchaseOption {
  id: number | null;
  external_variant_id: string | null;
  variant_name: string | null;
  sku: string | null;
  current_price: string | null;
  regular_price: string | null;
  is_in_stock: boolean | null;
  stock_quantity: number | null;
  image_url: string | null;
  thumbnail_url: string | null;
  url: string | null;
  grade_name: string | null;
  tube_supplier: string | null;
  phosphor_color: string | null;
  film: string | null;
  generation: string | null;
  gain_control: string | null;
  auto_gated: boolean | null;
}

export interface Product {
  details: ProductDetails;
  purchase_options: PurchaseOption[];
}

/** Derived listing stats — not returned by the API; compute from purchase_options. */
export interface ProductListingStats {
  has_available_variants: boolean;
  min_price: number | null;
  max_price: number | null;
  variant_count: number;
}

export interface FeaturedProduct {
  id: number;
  product_id: number;
  sort_order: number;
  context: string;
  start_date: string | null;
  end_date: string | null;
  created_at: string;
  updated_at: string;
}

export interface FeaturedProductCreate {
  product_id: number;
  context: FeaturedContext;
  sort_order?: number;
  start_date?: string | null;
  end_date?: string | null;
}

export interface FeaturedProductUpdate {
  product_id?: number;
  context?: FeaturedContext;
  sort_order?: number;
  start_date?: string | null;
  end_date?: string | null;
}

export interface ReorderItem {
  id: number;
  sort_order: number;
}
